import React from "react";
import { FormattedMessage } from "react-intl";
import styled from "styled-components";
import { TValidationError } from "./ValidationErrorsDialog";

const StyledList = styled.ul`
  margin: 0;
  padding: 0.5rem 0 0.5rem 2.5rem;
`;

const StyledErrorItem = styled.li`
  font-family: "Source Sans Pro", Arial, Helvetica, sans-serif;
  font-size: 0.875rem;
  margin: 0.125rem 0;
`;

interface IErrorList {
  errors: TValidationError[];
}

const ErrorList = (props: IErrorList) => {
  const { errors } = props;

  const showMore = errors.length > 3;
  const limitedErrors = errors.length > 3 ? errors.slice(0, 3) : errors;

  const renderedErrors: React.ReactNode[] = [];
  limitedErrors.forEach((error, i) => {
    renderedErrors.push(
      <StyledErrorItem key={`ervali_${i}`}>{error.message}</StyledErrorItem>
    );
  });

  if (showMore) {
    renderedErrors.push(
      <StyledErrorItem key="ervali_final">
        <FormattedMessage
          id="ErrorList.More"
          defaultMessage="y otros {num} errores más"
          values={{
            num: errors.length - 3,
          }}
        />
      </StyledErrorItem>
    );
  }

  return <StyledList>{renderedErrors}</StyledList>;
};

export default ErrorList;
